import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';

function LandingPage() {
    const navigate = useNavigate();
    const [texts, setTexts] = useState({
        mainTitle: '아트몰링 초성퀴즈',
        mainSubtitle: '초성에 맞는 단어를 맞혀보세요',
        startButtonText: '초성퀴즈 시작',
        rankingMainTitle: '초성퀴즈 타임어택',
        rankingMainSubtitle: '5문제를 가장 빠르게 맞혀보세요!'
    });
    const [rankingData, setRankingData] = useState({ totalCount: 0, topRankings: [] });

    useEffect(() => {
        fetch('/api/config')
            .then(res => res.json())
            .then(data => {
                if (data.mainTitle) setTexts(prev => ({ ...prev, ...data }));
            })
            .catch(err => console.error('Failed to load config:', err));
    }, []);

    useEffect(() => {
        fetch('/api/ranking/top')
            .then(res => res.json())
            .then(data => setRankingData(data))
            .catch(err => console.error('Failed to load rankings:', err));
    }, []);

    const handleStartGame = () => {
        navigate('/game', { state: { rows: 3, cols: 3, isRankingMode: true } });
    };

    return (
        <div className="page-container landing-page" style={{
            position: 'relative',
            width: '100%',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <div className="card">
                <h1 className="title">{texts.rankingMainTitle}</h1>
                <p className="subtitle">{texts.rankingMainSubtitle}</p>

                <div className="button-group">
                    <button onClick={handleStartGame} className="action-button">
                        {texts.startButtonText}
                    </button>
                </div>
            </div>

            <div className="ranking-board card">
                    <h2>🏆 랭킹판 🏆</h2>
                    <p className="ranking-count">총 참여인수: {rankingData.totalCount}명</p>
                    <div className="ranking-row ranking-header">
                        <span>#</span><span>이름</span><span>번호</span><span>시간</span>
                    </div>
                    {rankingData.topRankings.length > 0 ? rankingData.topRankings.map((rank, index) => (
                        <div className="ranking-row" key={`${rank.maskedPhone}-${index}`}>
                            <span>{index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : index + 1}</span>
                            <span>{rank.name}</span>
                            <span>{rank.maskedPhone}</span>
                            <span>{Number(rank.time).toFixed(2)}초</span>
                        </div>
                    )) : <p className="ranking-empty">아직 등록된 랭킹이 없습니다.</p>}
            </div>
        </div>
    );
}

export default LandingPage;
